import config from "@Config/index";
import axios from "axios";

const getInventoryReviewData = async ({
  id,
  page = 1,
  limit = 50,
  params = {},
  selectedLang = "en",
  user_encrypted = false,
  user,
}: any) => {
  const queryParams = {
    page,
    limit,
    ...params,
    lang: selectedLang,
    user_encrypted,
    ...(user && { user }),
  };

  return axios.get(`${config.API_URL}/api/v0/inventories/${id}/reviews`, {
    params: queryParams,
    withCredentials: true,
    ...config.apiParams,
  });
};

export default getInventoryReviewData;
